import PropTypes from 'prop-types';
import React from 'react';
import Icon from './../Icon';
import useInputRadio from './useInputRadio';

const InputRadio = ({ onChange, label, value, name, checked, disabled, description, checkedIcon, uncheckedIcon }) => {
  const { animation, handleClick, animationEnd } = useInputRadio({ onChange, checked });

  return (
    <label
      className={`input-radio ${disabled ? 'input-radio--disabled' : ''} ${checked ? 'input-radio--checked' : 'input-radio--unchecked'}`}
      onAnimationEnd={animationEnd}
      animation={animation}
    >
      <input type="radio" className={`input-radio__input `} name={name} onChange={handleClick} checked={checked} disabled={disabled} value={value} />
      <div className={`input-radio__icon-container input-radio__icon-container--${checked ? 'checked' : 'unchecked'} `}>
        <Icon type={checked ? checkedIcon : uncheckedIcon} color={checked ? 'primary' : 'default'} />
      </div>
      <div className="input-radio__texts">
        <span className={`input-radio__label ${description === '' ? 'input-radio__label--no-description' : ''}`}>{label}</span>
        <span className="input-radio__description">{description}</span>
      </div>
    </label>
  );
};

InputRadio.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  name: PropTypes.string,
  description: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  checkedIcon: PropTypes.string,
  uncheckedIcon: PropTypes.string,
};

InputRadio.defaultProps = {
  checkedIcon: 'check-checked-round',
  uncheckedIcon: 'check-unchecked-round',
  description: '',
  label: '',
  onChange: () => {},
  checked: false,
  disabled: false,
};

export default InputRadio;
